import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
const SVG = ({
  className = '',
  size = '24'
}) => ___EmotionJSX("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: size,
  height: size,
  className: className,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, ___EmotionJSX("rect", {
  x: "2",
  y: "2",
  width: "20",
  height: "8",
  rx: "2",
  ry: "2"
}), ___EmotionJSX("rect", {
  x: "2",
  y: "14",
  width: "20",
  height: "8",
  rx: "2",
  ry: "2"
}), ___EmotionJSX("line", {
  x1: "6",
  y1: "6",
  x2: "6",
  y2: "6"
}), ___EmotionJSX("line", {
  x1: "6",
  y1: "18",
  x2: "6",
  y2: "18"
}));
export default SVG;